export default {
    US: [{
            code: 'boston',
            name: 'Boston'
        },
        {
            code: 'california',
            name: 'California'
        },
        {
            code: 'chicago',
            name: 'Chicago'
        },
        {
            code: 'dallas',
            name: 'Dallas'
        },
        {
            code: 'florida',
            name: 'Florida'
        },
        {
            code: 'georgia',
            name: 'Georgia'
        },
        {
            code: 'newyork',
            name: 'New york'
        },
        {
            code: 'texas',
            name: 'Texas'
        },
        {
            code: 'virginia',
            name: 'Virginia'
        },
        {
            code: 'washington',
            name: 'Washington'
        },
    ]
}